export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-mail-line',
      label: 'Email',
      value: 'help@iganadoo.com',
      link: 'mailto:help@iganadoo.com'
    },
    {
      icon: 'ri-phone-line',
      label: 'Phone',
      value: '+1 8576783755',
      link: 'tel:+18576783755'
    },
    {
      icon: 'ri-map-pin-line',
      label: 'Address',
      value: 'Ivana Plemenitog Zajca 18\n22300 Knin\nCroatia',
      link: null
    }
  ];

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Get in Touch</h2>
          <p className="text-gray-600 text-lg">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className={`${info.icon} text-5xl text-teal-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-3">{info.label}</h3>
              {info.link ? (
                <a
                  href={info.link}
                  className="text-teal-600 hover:text-teal-700 transition-colors text-base font-medium cursor-pointer"
                >
                  {info.value}
                </a>
              ) : (
                <p className="text-gray-700 text-base whitespace-pre-line leading-relaxed">
                  {info.value}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
